import React, { Component } from 'react';
import propTypes from 'prop-types';

import AttachChildModal from 'app/AttachChildModal/container';
import ChildrenComponentsList from 'app/ChildrenComponentsList/container';
import sharedStyles from 'app/shared.css';
import { variantsField } from 'lib/contract/experiment';
import { makeId } from 'utils/selectors';
import { API_COMPONENT_ACTION_ADDED } from 'utils/factory';

import HelpIcon from './HelpIcon';

/**
 * render an input that allows attaching children to container components
 * supports attaching new or existing components
 * @param {object} props - props passed to this component
 * @returns {React.Component} AttachChildInput canvas widget
 */
export default class AttachChildInput extends Component {
  static propTypes = {
    beforeRemove: propTypes.func,
    boundOpenComponentForEditing: propTypes.func.isRequired,
    isExperimentComponent: propTypes.bool,
    fieldContract: propTypes.shape({
      allowedChildComponents: propTypes.arrayOf(propTypes.string),
      helpText: propTypes.string,
      name: propTypes.string,
      required: propTypes.bool
    }).isRequired,
    isReadonly: propTypes.bool,
    items: propTypes.arrayOf(propTypes.shape()).isRequired,
    modifyComponent: propTypes.func.isRequired,
    onChange: propTypes.func.isRequired,
    updateLocation: propTypes.string.isRequired,
    validationMessage: propTypes.string
  };

  static defaultProps = {
    beforeRemove: () => true,
    isExperimentComponent: false,
    isReadonly: false,
    validationMessage: ''
  };

  constructor(props) {
    super(props);

    this.onComponentSelected = this.onComponentSelected.bind(this);
  }

  /**
   * adds new/existing component to the list of components
   * @param {object} component - selected component object (new/existing)
   */
  onComponentSelected(component) {
    const {
      boundOpenComponentForEditing,
      isExperimentComponent,
      items,
      modifyComponent,
      updateLocation
    } = this.props;
    const newItem = isExperimentComponent
      ? { data: component, variant: variantsField.defaultParameter }
      : component;
    modifyComponent([...items, newItem], updateLocation);
    if (component.Action === API_COMPONENT_ACTION_ADDED) {
      boundOpenComponentForEditing(component);
    }
  }

  render() {
    const {
      beforeRemove,
      boundOpenComponentForEditing,
      fieldContract: { allowedChildComponents, helpText, name, required },
      isExperimentComponent,
      isReadonly,
      items,
      onChange,
      updateLocation,
      validationMessage
    } = this.props;

    return (
      <div className="d-flex flex-column my-3">
        <span className="d-flex align-items-center font-weight-bold mb-2">
          {`${name}${required ? '*' : ''}`}
          {helpText && <HelpIcon id={makeId({ updateLocation })} message={helpText} />}
        </span>
        <AttachChildModal
          className="mb-2"
          allowedChildComponents={allowedChildComponents}
          isReadonly={isReadonly}
          onComponentSelected={this.onComponentSelected}
          data-test-id={makeId({
            updateLocation,
            name: 'modal'
          })}
        />
        <ChildrenComponentsList
          beforeRemove={beforeRemove}
          isExperimentComponent={isExperimentComponent}
          isReadonly={isReadonly}
          items={items}
          openComponentForEditing={boundOpenComponentForEditing}
          onChange={onChange}
          data-test-id={makeId({
            updateLocation,
            name: 'children'
          })}
        />
        {!!validationMessage && (
          <span className={sharedStyles.fieldValidationMessage}>{validationMessage}</span>
        )}
      </div>
    );
  }
}
